import styles from './chip.module.scss'

export function Chip({ children }) {
  return <div className={styles.chip}>{children}</div>
}
